import React, {Component} from 'react';
import {OTSubscriber} from 'opentok-react';
import {connect} from 'react-redux';
import * as actions from '../../actions/index';

import PropTypes from 'prop-types';

const propTypes = {
    audio: PropTypes.bool,
    video: PropTypes.bool,
    onSubscribe: PropTypes.func,
    onError: PropTypes.func,
};

let interval;

class Subscriber extends Component {
    constructor(props) {
        super(props);

        this.subscriberRef = React.createRef();
        this.state = {
            error: null,
            audio: true,
            video: true
        };
        this.subscriberEventHandlers = {
            videoDisabled: event => {
                //console.log('Subscriber video disabled!');
            },
            videoEnabled: event => {
                //console.log('Subscriber video enabled!');
            }
        };

        this.getStatsDetails()
    }


    onError = (err) => {
        //console.log(err);
        this.setState({error: `Failed to subscribe: ${err.message}`});
    }

    UNSAFE_componentWillReceiveProps(nextProps){
        if (this.props.stream) {
            const element = document.getElementsByClassName("OTSubscriberContainer")[0]
            if (element){
                element.style.height = nextProps.children[1];

            }
        }
    }

    componentWillUnmount () {
        clearInterval(interval)
    }

    getStatsDetails = () => {
        const thisRef = this
        interval = setInterval(function () {
            thisRef.subscriberRef.current.getSubscriber().getStats((err, stats) => {
                if (err === null){
                    if (thisRef.props.getStatsDetails) {
                        thisRef.props.getStatsDetails(stats)
                    }

                }

            });
        }, 2000);

    }

    render() {
        const {audio,height,isTransactionPending} = this.props;
        //let hght = (height == "undefined" || height==null || height=="null") ? "500px" : height;
        //hght = (this.props.device.name.toLowerCase() === "safari") ? "457px" : hght;
        const hght = `${document.getElementsByClassName("video-container")[0].offsetHeight}px`;
        return (
            <div id={"sub-id"}>
                {this.state.error ? <div>{this.state.error}</div> : null}
                <OTSubscriber
                    ref={this.subscriberRef}
                    session={this.props.session}
                    stream={this.props.stream}
                    properties={{
                        showControls: this.props.device.name.toLowerCase() === "safari",
                        subscribeToAudio: (isTransactionPending === undefined || isTransactionPending === null) ? (this.props.device.name.toLowerCase() === "safari" ? audio : this.state.audio) : !isTransactionPending,
                        subscribeToVideo: (isTransactionPending === undefined || isTransactionPending === null) ? this.state.video : !isTransactionPending,
                        fitMode: "cover",
                        height: hght,
                        width: "100%"
                    }}
                    eventHandlers={this.subscriberEventHandlers}
                    onSubscribe={()=>{
                        if (this.props.setOTSession) {
                            this.props.setOTSession(this.props.session);
                            this.props.onSubscribe()
                        }
                    }}
                    onError={this.onError}
                />
            </div>
        );
    }
}

Subscriber.propTypes = propTypes;

function mapStateToProps(state, ownParams) {
    return {
        device: state.device.payload,
    };
}

export default connect(mapStateToProps, actions)(Subscriber);